import { render, staticRenderFns } from "./StudioGifts.vue?vue&type=template&id=30869be0&scoped=true&"
import script from "./StudioGifts.vue?vue&type=script&lang=js&"
export * from "./StudioGifts.vue?vue&type=script&lang=js&"
import style0 from "./StudioGifts.vue?vue&type=style&index=0&id=30869be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30869be0",
  null
  
)

export default component.exports